import React from 'react';

const NoteCard = ({ children }) => (
    <div className="mb-6 p-4 rounded-lg bg-blue-50 border-l-4 border-blue-400 flex items-center shadow-sm">
        <svg className="w-6 h-6 text-blue-400 mr-3 flex-shrink-0" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M13 16h-1v-4h-1m1-4h.01M12 20a8 8 0 100-16 8 8 0 000 16z" />
        </svg>
        <span className="text-blue-900 font-medium">{children}</span>
    </div>
);

export default NoteCard;
